import { mediaMax } from "components/designV2/breakpoints";
import { Spacing } from "components/designV2/constants";
import { Text } from "components/designV2/text/text";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const PassSettingSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
  padding: ${Spacing.lg}px 0;

  &:first-child {
    padding-top: 0;
  }
`;

export const PassSettingRow = styled.div<{
  $controlVerticalAlign?: "center" | "start";
}>`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: ${Spacing.lg}px;
  align-items: ${(props) =>
    props.$controlVerticalAlign === "center" ? "center" : "start"};

  ${mediaMax.tablet} {
    grid-template-columns: 1fr;
  }
`;

export const PassSettingText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.xs}px;
  min-width: 0;
`;

export const PassSettingTitle = styled(Text).attrs({
  color: ColorV2.Blue1,
  typography: "b1",
})`
  margin: 0;
`;

export const PassSettingDescription = styled(Text).attrs({
  color: ColorV2.Blue4,
  typography: "s1",
})`
  margin: 0;
  max-width: 560px;
  white-space: pre-line;
`;

export const PassSettingHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const PassSettingControls = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${Spacing.md}px;
  flex-wrap: wrap;
  justify-content: flex-end;

  ${mediaMax.tablet} {
    justify-content: flex-start;
  }
`;

export const PassSettingControl = styled.div`
  min-width: 128px;
`;

export const PassSettingLabeledControl = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.xs}px;
  min-width: 128px;
`;

export const PassSettingControlLabel = styled(Text).attrs({
  color: ColorV2.Blue4,
  typography: "s1",
})`
  margin: 0;
`;

export const SettingsCheckboxGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(180px, 1fr));
  gap: ${Spacing.md}px ${Spacing.lg}px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const SettingsGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
`;

export const SettingsGroupTitle = styled.div`
  ${TypographyV2.b1}
  color: ${ColorV2.Blue1};
`;

export const SettingsSubRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
`;

export const SettingsSubRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: ${Spacing.lg}px;
  align-items: center;

  ${mediaMax.tablet} {
    grid-template-columns: 1fr;
    align-items: start;
  }
`;

export const PassInputSeparator = styled.span`
  width: 14px;
  height: 2px;
  align-self: center;
  border-radius: 999px;
  background: ${ColorV2.Blue5};
`;

export const PassBooleanControl = styled.div`
  display: inline-flex;
`;

export const PassSettingSwitch = styled.button<{ $active: boolean }>`
  position: relative;
  width: 48px;
  height: 28px;
  flex: 0 0 auto;
  border: 0;
  border-radius: 999px;
  padding: 3px;
  background: ${(props) => (props.$active ? ColorV2.Blue1 : ColorV2.Blue6)};
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:focus-visible {
    outline: 2px solid ${ColorV2.ElectricBlue};
    outline-offset: 2px;
  }
`;

export const PassSettingSwitchThumb = styled.span<{ $active: boolean }>`
  display: block;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  background: ${ColorV2.White};
  transform: translateX(${(props) => (props.$active ? "20px" : "0")});
  transition: transform 0.15s ease;
`;
